import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useRedirectIfAuthenticated = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("lingoPortalToken");
    if (token) {
      navigate("/school/client", { replace: true });
    }
  }, [navigate]);
};

export default useRedirectIfAuthenticated;
